angular.module('Itao.IndicatorMap').directive('stackedSetBarChart', function (d3, mapConfig) {
  'use strict';

  var accessor = d3.hyperion.accessor;
  var compose = d3.hyperion.compose;
  var germanNumberFormat = d3.hyperion.germanFormat.numberFormat;
  var colors = [];
  var color = d3.hyperion.indicatorColorAt;
  var sortedAccessor = function (d, i) {
    return i;
  };

  var innerColor = function (d) {
    return accessor('color')(d);
  };

  var whiteToOpacity = function (d) {
    return d.color.toLowerCase() === '#ffffff' ? 0 : 1;
  };

  var offsetMappingFunction = function (propertyName) {
    return function (listObject, index, listArray) {
      // calculate the offset for each element in a list by the sum of the preceding elements
      listObject.offset = listArray.slice(0, index).reduce(function (sum, currentListObject) {
        return sum + currentListObject[propertyName];
      }, 0);
      return listObject;
    };
  };

  var sumMappingFunction = function (valuePropertyName, listPropertyName) {
    return function (listObject) {
      // only calculate sum if this has subElements
      if (listObject[listPropertyName] !== null) {
        // calculate the sum of a list by using the last offset and value
        var lastValue = listObject[listPropertyName][listObject[listPropertyName].length - 1];

        if (lastValue != null) {
          listObject.sum = lastValue.offset + lastValue[valuePropertyName];
        } else {
          listObject.sum = 0;
          console.warn('Last value in listObject not found:', listObject);
        }
      }

      if (!listObject.hasOwnProperty('isList') && listObject.unit === "%") {
        listObject.nOffset = 100 - listObject.sum;
        listObject.sum = 100;
      }
      return listObject;
    };
  };

  var combineData = function (layer, selectedIndicatorSet, disabledDistrictKeys, disabledListIndex, colorset, legend, useAbsoluteValues) {
    var indicatorsWithoutLists = selectedIndicatorSet.indicators.filter(function (indicator) {
      return indicator.list === false;
    });
    var listsAndIndicators = indicatorsWithoutLists
      .concat(selectedIndicatorSet.lists)
      .sort(function (a, b) {
        return a.listIndex - b.listIndex;
      })
      .map(function (listOrIndicator, index, allElements) {
        var subElementsCount = 0;
        if (index === 0) {
          listOrIndicator.legendIndex = 0;
        } else {
          if (allElements[index - 1] && allElements[index - 1].hasOwnProperty('indicators')) {
            subElementsCount = allElements[index - 1].indicators.length;
          }
          listOrIndicator.legendIndex = allElements[index - 1].legendIndex + subElementsCount + 1;
        }
        return listOrIndicator;
      });

    return Object.keys(layer.districts).filter(function (districtUid) {
      return disabledDistrictKeys.indexOf(layer.districts[districtUid].key) === -1;
    }).map(function (districtUid) {
      var barIndex = -1;
      return {
        // first level: districts
        unit: useAbsoluteValues ? '' : '%',
        key: layer.districts[districtUid].key,
        name: layer.districts[districtUid].name,
        hasNoGeoData: layer.districts[districtUid].hasNoGeoData,
        listValues: listsAndIndicators.map(function (listOrIndicator, index) {
          // second level: indicatorLists
          var isList = listOrIndicator.hasOwnProperty('indicators');
          var subValues = null;
          var sum = 0;
          var prefix = isList ? (listOrIndicator.indicators[0] != null ? listOrIndicator.indicators[0].prefix : '') : listOrIndicator.prefix;
          barIndex++;

          var listOrIndicatorName = isList ? listOrIndicator.title : listOrIndicator.name;
          if (legend != null) {
            if (legend.chart.scales.hasOwnProperty(listOrIndicator.legendIndex)) {
              listOrIndicatorName = legend.chart.scales[listOrIndicator.legendIndex].text;
            } else {
              console.warn('Scale is missing index ' + listOrIndicator.legendIndex + ' using ' + listOrIndicatorName + ' instead.');
            }
          }

          if (isList) {
            // get values for every indicator in the list
            subValues = listOrIndicator.indicators.map(function (indicator, index) {
              barIndex++;
              if (!layer[districtUid] || !layer[districtUid].hasOwnProperty(indicator.uid)) {
                return null;
              }
              // third level: values per indicator
              var valueLegendIndex = listOrIndicator.legendIndex + index + 1;
              var value = 0;
              if (layer[districtUid][indicator.uid] != null) {
                value = (+layer[districtUid][indicator.uid]);
              }
              var description = '';
              if (layer['descriptions'][districtUid] && layer['descriptions'][districtUid][indicator.uid] != null) {
                description = layer['descriptions'][districtUid][indicator.uid];
              }

              var valueName = indicator.name;
              if (legend != null) {
                if (legend.chart.scales.hasOwnProperty(valueLegendIndex)) {
                  valueName = legend.chart.scales[valueLegendIndex].text;
                } else {
                  console.warn('Scale is missing index ' + listOrIndicator.legendIndex + '. Using ' + valueName + ' instead.');
                }
              }

              return {
                value: value,
                description: description,
                unit: indicator.unit,
                prefix: indicator.prefix,
                offset: 0,
                name: valueName,
                color: colorset[valueLegendIndex % colorset.length],
                legendIndex: valueLegendIndex,
                idx: barIndex,
                key: indicator.key
              };
            }).filter(function (value) {
              return value !== null;
            }).map(offsetMappingFunction('value'));
          } else {
            var description = '';
            if (layer['descriptions'][districtUid] && layer['descriptions'][districtUid][listOrIndicator.uid] != null) {
              description = layer['descriptions'][districtUid][listOrIndicator.uid];
            }
            // value for single indicator without list
            if (layer[districtUid] && layer[districtUid].hasOwnProperty(listOrIndicator.uid)) {
              sum = (+layer[districtUid][listOrIndicator.uid]);
            } else {
              sum = null;
            }
          }

          return {
            isList: isList,
            description: description,
            name: listOrIndicatorName,
            key: listOrIndicator.key,
            uid: listOrIndicator.uid,
            prefix: prefix,
            firstLevel: true,
            sum: sum,
            unit: listOrIndicator.unit,
            offset: 0,
            idx: barIndex,
            legendIndex: listOrIndicator.legendIndex,
            color: colorset[listOrIndicator.legendIndex % colorset.length],
            values: subValues
          };
        }).filter(function (item, idx) {
          return disabledListIndex.indexOf(idx) === -1;
        }).filter(function (listOrIndicator) {
          return (listOrIndicator.isList === false && listOrIndicator.sum !== null) || (listOrIndicator.isList && listOrIndicator.values.length > 0);
        }).map(sumMappingFunction('value', 'values'))
          .map(offsetMappingFunction('sum'))
          .map(function (listOrIndicator) {
            // add empty array for values in indicator
            if (!listOrIndicator.isList) {
              listOrIndicator.values = [];
            }
            return listOrIndicator;
          })
      };
    }).map(sumMappingFunction('sum', 'listValues'));
  };

  var stackedSetBarChart = function () {
    var indicators = [],
      svgHeight = 200,
      useAbsoluteValues = false,
      displayValues = false,
      margin = {top: 40, right: 40, bottom: 30, left: 50},
      duration = 400,
      numberFormat = germanNumberFormat(',.2f'),
      tip,
      redLines = null,
      decimals,
      maxAxisValue,
      mouseOverFeature = null,
      sumTip;

    var chart = function (selection) {
      selection.each(function (data) {
        var yAxisFormatter = germanNumberFormat(useAbsoluteValues ? ',' : '%');
        var yFormatter = germanNumberFormat(',.' + (useAbsoluteValues ? mapConfig.absoluteIndicatorsDecimalPlaces : mapConfig.relativeIndicatorsDecimalPlaces) + '%');
        var getLabelBy = function (property, d, featureData) {
          return d.prefix + ((d.unit === '%') ? yFormatter(d[property] / 100) : (germanNumberFormat(',.' + decimals + 'f')(d[property]) + ' (' + yFormatter(d[property] / featureData.sum) + ')'));
        }

        var container = d3.select(this).datum([data]).classed('stacked-set-bar-chart', true);
        var svgWidth = selection.node().offsetWidth - 10; // add 10px space for preventing scrollbars

        var width = svgWidth - margin.left - margin.right,
          height = svgHeight - margin.top - margin.bottom;

        if (angular.isDefined(tip)) {
          tip.destroy();
        }
        if (angular.isDefined(sumTip)) {
          sumTip.destroy();
        }

        sumTip = d3.tip()
          .attr('class', 'd3-tip')
          .offset(function () {
            return [-5, 0];
          })
          .html(function (d, i, j) {
            if (!decimals) {
              decimals = d.unit === '%' ? mapConfig.relativeIndicatorsDecimalPlaces : mapConfig.absoluteIndicatorsDecimalPlaces;
            }
            var featureData = values[j].parentNode.parentNode.__data__;
            var value = '';
            if (d.description) {
              value = d.description;
              return '<div class="d3-tip-border" style="border-color:#000000;"><b>' + featureData.name + ' (' + featureData.key + ')</b><br><span class="tooltip-value">' + value + '</span></div>';
            } else {
              value = getLabelBy('sum', d, featureData);
              return '<div class="d3-tip-border" style="border-color:#000000;"><b>' + featureData.name + ' (' + featureData.key + ')</b><br><span style="color:#000000;">' + d.name.replace(/<[^>]*>?/gm, '').trim() + ':</span> <span class="tooltip-value">' + value + '</span></div>';
            }
          });

        tip = d3.tip()
          .attr('class', 'd3-tip')
          .offset(function () {
            return [-5, 0];
          })
          .html(function (d, i, j) {
            var featureData = values[j].parentNode.parentNode.__data__;
            var value = '';
            if (d.description) {
              value = d.description;
              return '<div class="d3-tip-border" style="border-color:#000000;"><b>' + featureData.name + ' (' + featureData.key + ')</b><br><span class="tooltip-value">' + value + '</span></div>';
            } else {
              value = getLabelBy('value', d, featureData);
              return '<div class="d3-tip-border" style="border-color:#000000;"><b>' + featureData.name + ' (' + featureData.key + ')</b><br><span style="color:#000000;">' + d.name.replace(/<[^>]*>?/gm, '').trim() + ':</span> <span class="tooltip-value">' + value + '</span></div>';
            }
          });

        var svg = container.selectAll('svg').data([data]);
        var svgEnter = svg.enter()
          .append('svg')
          .attr('preserveAspectRatio', 'xMidYMid meet'); // keep aspectratio on resize, see https://developer.mozilla.org/de/docs/Web/SVG/Attribute/preserveAspectRatio

        svg.attr('viewBox', '0 0 ' + svgWidth + ' ' + svgHeight)
          .attr('height', svgHeight)
          .attr('width', svgWidth); // set viewBox of the svg

        var g = svg.selectAll('.margin-group').data([data]);
        var gEnter = g.enter()
          .append('g')
          .attr('class', 'margin-group');

        svg.selectAll('.margin-group').transition().duration(duration).attr('transform', 'translate(' + margin.left + ',' + margin.top + ')'); // apply conventional margins, see http://bl.ocks.org/mbostock/3019563

        var featureScale = d3.scale.ordinal()
          .rangeRoundBands([0, width], 0.4)
          .domain(data.map(accessor('key')));

        var maxDomainValue = maxAxisValue ? maxAxisValue : useAbsoluteValues ? d3.max(data, accessor('sum')) : 1;

        var barScale = d3.scale.linear()
          .domain([0, maxDomainValue])
          .range([height, 0]);

        var tickCount = Math.min(svgHeight / 40, 10);

        var yAxis = d3.svg.axis()
          .scale(barScale)
          .ticks(tickCount)
          .tickFormat(function (d) {
            return indicators[0].prefix + yAxisFormatter(d).replace('%', '');
          })
          .orient('left');

        var xAxis = d3.svg.axis()
          .scale(featureScale)
          .orient('bottom');

        g.call(d3.hyperion.addHorizontalGridLines(barScale, width, 0, tickCount, duration));
        redLines = redLines ? redLines : mapConfig.redLines;

        if (useAbsoluteValues) {
          g.call(d3.hyperion.addHorizontalHighlightArea(redLines, barScale, featureScale, width, duration));
        }

        gEnter.append('g')
          .attr('class', 'x axis')
          .attr('transform', 'translate(0,' + height + ')');

        g.select('.x.axis')
          .attr('transform', 'translate(0,' + height + ')')
          .call(xAxis)
          .selectAll('text')
          .data(data)
          .style('font-weight', function (d) {
            return accessor('selected')(d) ? 'bold' : 'normal';
          })
          .style('fill', function (d) {
            return accessor('hasNoGeoData')(d) ? '#aaa' : '#000';
          });

        gEnter.append('g')
          .attr('class', 'y axis');

        g.select('.y.axis')
          .call(yAxis);

        svgEnter.append('text')
          .attr('class', 'axis-unit-label')
          .attr('text-anchor', 'end')
          .attr('transform', 'translate(' + (margin.left - 7) + ', 10)')
          .text(useAbsoluteValues ? '' : 'in %');

        var features = g.selectAll('.feature')
          .data(data, accessor('key'));

        features.enter()
          .append('g')
          .classed('feature', true)
          .attr('transform', function (d) {
            return 'translate(' + featureScale(accessor('key')(d)) + ',0)';
          });

        features
          .transition().duration(duration)
          .attr('transform', function (d) {
            // update avoid 100% bars
            if (d.unit === '%' && d.nOffset && d.nOffset > 1) {
              //return 'translate(' + featureScale(accessor('key')(d)) + ', 0)';
              return 'translate(' + featureScale(accessor('key')(d)) + ',' + (barScale((100 - d.nOffset) / 100)) + ')';
            } else {
              return 'translate(' + featureScale(accessor('key')(d)) + ',0)';
            }
          });

        features.exit().remove();

        var lists = features.selectAll('.list')
          .data(accessor('listValues'), accessor('uid'));

        lists
          .enter()
          .append('g')
          .attr('class', 'list')
          .attr('transform', 'translate(0,' + barScale(0) + ')');

        lists.transition().duration(duration)
          .attr('transform', function (d, i, j) {
            // update avoid 100% bars
            var barValue = useAbsoluteValues ? (lists[j].parentNode.__data__.sum - d.offset) : (lists[j].parentNode.__data__.sum - d.offset) / 100;
            var offsetValue= useAbsoluteValues ? (lists[j].parentNode.__data__.sum - d.offset) : (lists[j].parentNode.__data__.sum ) / 100;
            if(mouseOverFeature !== null) {

              var barHeight = useAbsoluteValues ? d.sum : d.sum / 100;
              return 'translate(0,' + (barScale(barHeight)) + ')';
            } else {
              //var barValue = useAbsoluteValues ? (lists[j].parentNode.__data__.sum - d.offset) : (lists[j].parentNode.__data__.sum - d.offset) / lists[j].parentNode.__data__.sum;
              return 'translate(0,' + barScale(barValue) + ')';
            }
          });

        lists.exit().remove();

        var sumBars = lists.selectAll('.sum')
          .data(function (d) {
            return [{
              sum: d.sum,
              color: d.color,
              name: d.name,
              isList: d.isList,
              unit: d.unit,
              prefix: d.prefix,
              description: d.description,
              key: d.key,
              idx: d.legendIndex
            }];
          });

        sumBars.enter()
          .append('rect')
          //.attr('class', 'sum')
          .attr('class', function (d) {
            return 'sum focus-bar_' + d.idx + (d.isList ? '' : ' sum__' + d.key);
          })
          .classed('sum-only', function (d) {
            return !d.isList;
          })
          .attr('y', 0)
          .attr('fill', innerColor)
          .attr('fill-opacity', whiteToOpacity)
          .attr('width', featureScale.rangeBand())
          .attr('height', 0);

        sumBars.transition().duration(duration)
          .attr('fill', innerColor)
          .attr('fill-opacity', whiteToOpacity)
          .attr('width', featureScale.rangeBand())
          .attr('height', function (d, i, j) {
            // update avoid 100% bars
            var barValue = useAbsoluteValues ? d.sum : d.sum / 100;

            // fetch sum from feature for scaling the sum
            //var barValue = useAbsoluteValues ? d.sum : d.sum / sumBars[j].parentNode.parentNode.__data__.sum;
            return height - barScale(barValue);
          });

        var values = lists.selectAll('.value')
          .data(accessor('values'));

        values.enter()
          .append('rect')
          .attr('class', 'value')
          .attr('x', 0)
          .attr('width', featureScale.rangeBand())
          .attr('fill', innerColor)
          .attr('fill-opacity', whiteToOpacity)
          .attr('height', 0);

        values.transition().duration(duration)
          .attr('fill', innerColor)
          .attr('fill-opacity', whiteToOpacity)
          .attr('class', function (d) {
            return "value " + d.key + ' focus-bar_' + d.legendIndex;
          })
          .attr('y', function (d, i, j) {
            // update avoid 100% bars
            var yValue = useAbsoluteValues ? d.offset : d.offset / 100;
            //var yValue = useAbsoluteValues ? d.offset : d.offset / values[j].parentNode.parentNode.__data__.sum;
            return height - barScale(yValue);
          })
          .attr('height', function (d, i, j) {
            // update avoid 100% bars
            var heightValue = useAbsoluteValues ? d.value : d.value / 100;
            //var heightValue = useAbsoluteValues ? d.value : d.value / values[j].parentNode.parentNode.__data__.sum;
            return height - barScale(heightValue);
          })
          .attr('width', featureScale.rangeBand());

        if (values.size() > 0) {
          values.call(tip);
          values.on('mouseover', function (d, i, j) {
            if (d.color.toLowerCase() !== '#ffffff') {
              tip.show(d, i, j);
            }
          }).on('mouseout', function (d) {
            if (d.color.toLowerCase() !== '#ffffff') {
              tip.hide(d);
            }
          });
        }

        var labels = lists.selectAll('text')
          .data(function (d) {
            return [{
              sum: d.sum,
              color: d.color,
              name: d.name,
              isList: d.isList,
              unit: d.unit,
              prefix: d.prefix,
              description: d.description,
              key: d.key,
              idx: d.legendIndex
            }];
          });

        labels.enter()
          .append('text')
          .attr('class', 'sum-label')
          .attr('y', 0);

        // update labels
        labels
          //.attr("class", "sum-label vertical")
          .attr('class', function (d) {
            return "sum-label vertical " + " focus-bar_" + d.idx;
          })
          .text(function (d,i,j) {
            var featureData = values[j].parentNode.parentNode.__data__;

            return getLabelBy('sum', d, featureData);
          })
          .attr('x', function (d, i) {
            return (featureScale.rangeBand() / 2) + (featureScale.rangeBand() * i);
          })
          .attr('dy', 12);
        // remove unused labels
        labels.exit()
          .remove();

        var sumOnly = lists.selectAll('.sum-only');
        if (sumOnly.size() > 0) {
          sumOnly.call(sumTip);
          lists.selectAll('.sum-only').on('mouseover', function (d, i, j) {
            if (d.color.toLowerCase() !== '#ffffff') {
              sumTip.show(d, i, j);
            }
          }).on('mouseout', function (d) {
            if (d.color.toLowerCase() !== '#ffffff') {
              sumTip.hide(d);
            }
          });
        }

        values.exit().transition().duration(duration)
          .attr('width', 0)
          .attr('height', 0)
          .remove();

        sumBars.exit().transition().duration(duration)
          .attr('width', 0)
          .attr('height', 0)
          .remove();

        if (useAbsoluteValues) {
          g.selectAll('line.highlightLine').remove();
          g.call(d3.hyperion.addHorizontalHighlightLines(redLines, barScale, width, duration));
        }
      });
    };

    /**
     * getter/setter for indicators
     * @param {Array} [newIndicators] set of new indicators
     * @returns {*}
     */
    chart.indicators = function (newIndicators) {
      if (!arguments.length) {
        return indicators;
      } else {
        indicators = newIndicators;
        return chart;
      }
    };

    /**
     * getter/setter for svgHeight
     * @param {int} [newHeight] height of the diagram
     * @returns {*}
     */
    chart.height = function (newHeight) {
      if (!arguments.length) {
        return svgHeight;
      } else {
        svgHeight = newHeight;
        return chart;
      }
    };

    /**
     * getter/setter for useAbsoluteValues
     * @param {int} [newUseAbsoluteValues] height of the diagram
     * @returns {*}
     */
    chart.useAbsoluteValues = function (newUseAbsoluteValues) {
      if (!arguments.length) {
        return useAbsoluteValues;
      } else {
        useAbsoluteValues = newUseAbsoluteValues;
        return chart;
      }
    };

    /**
     *
     * @returns {*}
     */
    chart.tip = function () {
      return tip;
    };

    /**
     * getter/setter for displayValues
     * @param {int} [newDisplayValues] height of the diagram
     * @returns {*}
     */
    chart.displayValues = function (newDisplayValues) {
      if (!arguments.length) {
        return displayValues;
      } else {
        displayValues = newDisplayValues;
        return chart;
      }
    };

    /**
     * getter/setter for displayValues
     * @param {int} [newDecimals] height of the diagram
     * @returns {*}
     */
    chart.decimals = function (newDecimals) {
      if (!arguments.length && !decimals) {
        return decimals;
      } else {
        decimals = newDecimals;
        return chart;
      }
    };

    /**
     * getter/setter for displayValues
     * @param {float} [newMaxAxisValue] height of the diagram
     * @returns {*}
     */
    chart.maxAxisValue = function (newMaxAxisValue) {
      if (!arguments.length) {
        return maxAxisValue;
      } else {
        maxAxisValue = newMaxAxisValue;
        return chart;
      }
    };

    /**
     * getter/setter for redLines
     * @param {Function} [newRedLines] new redLines function
     * @returns {*}
     */
    chart.redLines = function (newRedLines) {
      if (!arguments.length) {
        return redLines;
      } else {
        redLines = newRedLines;
        return chart;
      }
    };

    /**
     * getter/setter for mouseOverFeature
     * @param {Function} [newMouseOverFeature] new mouseOverFeature function
     * @returns {*}
     */
    chart.mouseOverFeature = function (newMouseOverFeature) {
      if (!arguments.length) {
        return mouseOverFeature;
      } else {
        mouseOverFeature = newMouseOverFeature;
        return chart;
      }
    };

    return chart;
  };

  /**
   * @param {HTMLElement} element the chart element
   * @returns {number}
   */
  var calculateChartHeight = function (element, absolute) {
    var content = element.closest('.grid-stack-item-content-stackedSet' + (absolute ? 'Absolute' : '') + 'BarChart');
    return content.height() - jQuery(content).find('.selected-indicator-set').height() - jQuery(content).find('.no-indicator-set-selected').height() - 20;
  };

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'stackedSetBarChart.html',
    scope: {
      layer: '=',
      indicators: '=',
      colorsets: '=',
      useAbsoluteValues: '@',
      indicatorSets: '=',
      disabledDistrictKeys: '=',
      disabledListIndex: '=',
      dimensionX: '@',
      dimensionY: '@',
      mouseOverFeature: '=',
      config: '='
    },
    link: function (scope, element) {
      scope.config.selectedIndicatorSet = scope.config.selectedIndicatorSet || null;
      scope.config.districtLabelProperty = scope.config.districtLabelProperty || 'key';
      scope.indicatorSetToShow = scope.config.selectedIndicatorSet;
      scope.config.fullscreen = scope.config.fullscreen || false;
      scope.config.displayValues = scope.config.displayValues || false;
      scope.disabledListIndex = scope.disabledListIndex || [];

      var stackedSetBarChartFunction = stackedSetBarChart();

      var useAbsoluteValues = scope.useAbsoluteValues === '1';

      /**
       * update the chart from one of the watchers
       *
       * @param {*} watcherNewValue new value of the watcher
       * @param {*} watcherOldValue old value of the watcher
       * @param {*} watcherScope new scope from the watcher
       * @param {Number} newHeight the height for the svg
       */
      var rerender = function (watcherNewValue, watcherOldValue, watcherScope, newHeight) {
        if (Object.keys(scope.layer.districts).length === scope.disabledDistrictKeys.length) {
          return null;
        }
        if (newHeight == null) {
          newHeight = calculateChartHeight(element, useAbsoluteValues);
        }

        var indicators = scope.indicators;
        var redLines;
        var decimals = null;
        var maxAxisValue = null;

        scope.selectedIndicatorSet = [];
        if (angular.isArray(indicators) && indicators.length > 0 && indicators[0].isDefault) {
          // first selected indicator belongs to an indicatorSet
          var selectedSets = scope.indicatorSets.filter(function (set) {
            return set.uid === indicators[0].type;
          });
          if (selectedSets.length > 0) {
            scope.selectedIndicatorSet = selectedSets[0];
            scope.config.selectedIndicatorSet = selectedSets[0].uid;

            var defaultIndicatorUid = (+scope.selectedIndicatorSet.defaultIndicator.uid);
            var colorset = d3.hyperion.indicatorColors;
            var legend = null;
            if (scope.layer.legend != null && scope.layer.legend.hasOwnProperty(defaultIndicatorUid) && scope.layer.legend[defaultIndicatorUid].chart != null) {
              colorset = scope.colorsets.filter(function (colorset) {
                return (+colorset.uid) === (+scope.layer.legend[defaultIndicatorUid].chart.colorSet);
              })[0].colors.map(function (color) {
                return color.color;
              });
              legend = scope.layer.legend[defaultIndicatorUid];

              if (legend.chart && legend.chart.redLines) {
                redLines = legend.chart.redLines;
              }

              if (legend && legend.chart.decimals !== null) {
                decimals = legend.chart.decimals;
              }

              if (legend && legend.chart.maxAxisValue) {
                maxAxisValue = legend.chart.maxAxisValue;
              }
            }

            var data = combineData(scope.layer, scope.selectedIndicatorSet, scope.disabledDistrictKeys, scope.disabledListIndex, colorset, legend, useAbsoluteValues);

            stackedSetBarChartFunction
              .indicators(indicators)
              .useAbsoluteValues(useAbsoluteValues)
              .displayValues(scope.config.displayValues)
              .redLines(redLines)
              .decimals(decimals)
              .maxAxisValue(maxAxisValue)
              .mouseOverFeature(scope.mouseOverFeature)
              .height(newHeight);

            d3.select(element.find('.widget-inner:first')[0])
              .data([data])
              .call(stackedSetBarChartFunction);
          } else {
            scope.config.selectedIndicatorSet = null;
            d3.select(element[0]).select('svg').remove();
          }
        }
      };

      jQuery(document).on("fullscreen", rerender);

      var layerWatcher = scope.$watchCollection('layer', rerender);
      var indicatorWatcher = scope.$watchCollection('indicators', rerender);
      var indicatorSetWatcher = scope.$watchCollection('indicatorSets', rerender);
      var dimensionWatcher = scope.$watchGroup(['dimensionX', 'dimensionY'], rerender);
      var districtLabelPropertyWatcher = scope.$watch('config.districtLabelProperty', rerender);
      var selectedIndicatorSet = scope.$watch('indicatorSetToShow', rerender);
      var fullscreenWatcher = scope.$watch('config.fullscreen', rerender);
      var disabledDistrictKeysWatcher = scope.$watchCollection('disabledDistrictKeys', rerender);
      var displayValuesWatcher = scope.$watch('config.displayValues', rerender);
      var disabledListIndexWatcher = scope.$watch('disabledListIndex', rerender);
      var mouseOverFeatureWatcher = scope.$watch('mouseOverFeature', rerender);

      var legendHeightWatcher = scope.$watch(function () {
        return calculateChartHeight(element);
      }, function (newValue, oldValue) {
        if (newValue !== oldValue && newValue > 0) {
          rerender(newValue, oldValue, null, newValue);
        }
      });

      // remove watcher on destroy
      element.on('$destroy', function () {
        layerWatcher();
        indicatorWatcher();
        indicatorSetWatcher();
        dimensionWatcher();
        legendHeightWatcher();
        selectedIndicatorSet();
        districtLabelPropertyWatcher();
        fullscreenWatcher();
        disabledDistrictKeysWatcher();
        displayValuesWatcher();
        disabledListIndexWatcher();
        mouseOverFeatureWatcher();

        // remove tooltip dom element
        if (angular.isDefined(stackedSetBarChartFunction.tip())) {
          stackedSetBarChartFunction.tip().destroy();
        }
      });
    }
  };
});
